import TransfersVehicleType
    from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersVehicle.type";

export const hasFullSnippetsData = (vehicles: GbtVehicleSnippetType[] | TransfersVehicleType[]): vehicles is TransfersVehicleType[] => (
    ("priceWithCurrency" in vehicles[0]) || ("imageUrl" in vehicles[0])
)